<template>
  <div class="equipment-list">
    <el-row>
      <el-col
        :xs="{ span: 24, offset: 0 }"
        :sm="{ span: 24, offset: 0 }"
        :md="{ span: 22, offset: 1 }"
        :lg="{ span: 22, offset: 1 }"
        :xl="{ span: 18, offset: 3 }"
      >
        <div class="head">
          <el-breadcrumb
            separator-class="el-icon-arrow-right"
            class="breadcrumb"
          >
            <el-breadcrumb-item :to="{ path: '/' }">Home</el-breadcrumb-item>
            <el-breadcrumb-item>Equipment Supply</el-breadcrumb-item>
          </el-breadcrumb>
        </div>

        <div class="descriptions">
          <h1>Equipment Supply</h1>
          <p v-for="(item, index) in categoryDetail.descriptions" :key="index">
            {{ item }}
          </p>
        </div>

        <MouldExhibition
          :moulds="equipmentsExhibition"
          :loose="true"
          :disable="true"
        />
        <div class="equipments">
          <div
            v-for="(category, index) in categories"
            :key="index"
            :class="[
              'category',
              { right: index % 2 !== 0 },
              { 'not-first-row': index > 1 },
            ]"
          >
            <h5 class="category-title">
              {{ category }}
            </h5>
            <EquipmentsBoard
              :category="category"
              :equipment-list="equipmentListOfCategory(category)"
            />
          </div>
        </div>

        <div v-if="categoryDetail" class="qa">
          <h2 class="title">FAQ:</h2>
          <template v-for="(item, index) in categoryDetail.qas">
            <div :key="index">
              <h2>
                {{ item.q }}
              </h2>
              <p>
                {{ item.a }}
              </p>
            </div>
          </template>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import "./_EquipmentList.scss";
import equipmentList from "./equipments";
import EquipmentsBoard from "../../components/EquipmentsBoard/EquipmentsBoard";
import equipmentsExhibition from "./equipmentsExhibition";
import MouldExhibition from "../../components/ProductsItem/MouldExhibition";

export default {
  name: "EquipmentList",
  components: { MouldExhibition, EquipmentsBoard },
  data() {
    return {
      categories: Array.from(
        new Set(equipmentList.map((item) => item.Category))
      ),
      selectedEquipment: {},
      equipmentsExhibition,
      categoryDetail: {
        descriptions: [
          "Compared with other businesses, our equipment adopts the most advanced technology to produce, reduce costs, maximize the interests of customers, and provide customers with the best products in the shortest time. The shipment speed is fast and the cycle is short. And the materials used are of good quality.",
        ],
        qas: [
          {
            q: "1.How long does it take to make customized equipment?",
            a:
              "Creating a custom equipment take anywhere from 1-4 weeks. Different equipment takes different time and delivery time does not include shipping time.",
          },
          {
            q: "2.Can we see the process of equipment manufacturing?",
            a:
              "Of course, you can see which step the equipment has been manufactured, our process is visualized.",
          },
          {
            q: "3.Can I choose the materials myself for production?",
            a:
              "Of course, we accept customization. We will provide the best materials; you can also choose the materials by yourself.",
          },
        ],
      },
    };
  },
  computed: {},
  mounted() {
    const structureScript = document.getElementById("structureData");
    structureScript.type = "application/ld+json";
    const structureData = {
      "@context": "https://schema.org",
      "@type": "ItemList",
      url: window.location.href,
      name: "Equipment Supply",
      description: "Equipment Supply",
    };
    structureScript.innerText = JSON.stringify(structureData);

    const breadcrumb = document.getElementById("breadcrumb");
    const breadcrumbData = {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
    };

    breadcrumbData.itemListElement = [
      {
        "@type": "ListItem",
        position: 1,
        item: {
          "@id": `https://hic.cosmoplat.com/equipment-supply`,
          name: "Equipment Supply",
        },
      },
    ];

    breadcrumb.innerText = JSON.stringify(breadcrumbData);
  },
  methods: {
    equipmentListOfCategory(category) {
      return equipmentList.filter((x) => x.Category === category);
    },
  },
};
</script>
